import { CoreIcon } from '../core-icon';
import chevronRightCircleFillSVG from '../../assets/icons/chevron-right-circle-fill.svg';
import type { IconProps } from '../core-icon';

export const ChevronRightCircleFillIcon = (props: Omit<IconProps, 'src'>) => {
  return <CoreIcon src={chevronRightCircleFillSVG} {...props} />;
};
